import Indicator, { IndicatorType } from '../types/Indicator'

const WilliamsR: Indicator = {
  type: IndicatorType.OSCILLATOR,
  value: 'williamsR',
  label: 'Williams %R',
  nickname: 'Williams %R',
  fields: ['williamsR'],
  params: {
    period: 14,
  },
}

export default WilliamsR
